import { Helmet } from 'react-helmet';
import { sharingSocials } from './sharingSocials';

const SHARE_TITLE = 'Creating + Publishing 100 Bounties';
const SHARE_DESCRIPTION = 'Check out my achievement for leading climate action on Impact Foundry!';
const SHARE_IMAGE = sharingSocials[0]?.image;
const SHARE_URL = 'https://impactfoundry.app/share/12345';

const ShareCardPage = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white p-4">
            <Helmet>
                <title>{SHARE_TITLE}</title>
                <meta property="og:title" content={SHARE_TITLE} />
                <meta property="og:description" content={SHARE_DESCRIPTION} />
                <meta property="og:image" content={SHARE_IMAGE} />
                <meta property="og:url" content={SHARE_URL} />
                <meta property="og:type" content="website" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={SHARE_TITLE} />
                <meta name="twitter:description" content={SHARE_DESCRIPTION} />
                <meta name="twitter:image" content={SHARE_IMAGE} />
            </Helmet>

            <div className="bg-grayBgNormal text-textPrimary rounded-2xl shadow-xl p-6 max-w-sm w-full text-center">
                <img src={SHARE_IMAGE} alt="Share Preview" className="rounded-xl mb-4 w-full h-auto" />
                <h1 className="text-xl font-semibold mb-2">{SHARE_TITLE}</h1>
                <p className="text-sm text-gray-700">{SHARE_DESCRIPTION}</p>
            </div>
        </div>
    );
};

export default ShareCardPage;
